import {addDays, addHours, format, setHours} from 'date-fns'
import {observer} from 'mobx-react-lite'
import React from 'react'
import {Shift, TaskWithColor, useCalendarStore} from '../calendar-store'
import {Hour} from './hour/hour'

const dateFormat = 'yyyy-MM-dd'

interface Props {
  currentHour: number
  shift: Shift
  tasksWithStartDate: TaskWithColor[]
}

const getTasksWithShift = (
  tasksWithoutStartDate: TaskWithColor[],
  startWith = 0
): TaskWithColor[] => {
  const currentTask = tasksWithoutStartDate[startWith]
  const nextTask = tasksWithoutStartDate[startWith + 1]

  const tasks = tasksWithoutStartDate.map((task, ix) => {
    const nextTaskDeadline = nextTask?.roundedDeadline
    if (startWith < ix && nextTaskDeadline === task.roundedDeadline) {
      return {
        ...task,
        marginShiftLeft: Math.max(
          task.marginShiftLeft + 1,
          currentTask.marginShiftLeft + 1
        )
      }
    }
    return task
  })

  if (nextTask) {
    return getTasksWithShift(tasks, startWith + 1)
  }

  return tasks
}

export const Day = observer(
  ({currentHour, shift, tasksWithStartDate}: Props) => {
    const [, store] = useCalendarStore()
    const tasksWithoutStartDate = store.getTasksWithoutStartDate(shift)

    return (
      <>
        {new Array(7).fill(null).map((_, day) => {
          const currentDate = setHours(
            new Date(format(addDays(store.startDate(shift), day), dateFormat)),
            0
          )
          const hour = setHours(currentDate, currentHour)

          const start = hour
          const end = addHours(new Date(hour), 1)

          const tasksWithShift = getTasksWithShift(
            tasksWithoutStartDate.filter(
              task =>
                format(task.roundedDeadline, 'yyyy-MM-dd HH') ===
                format(hour, 'yyyy-MM-dd HH')
            )
          )

          return (
            <Hour
              day={day}
              shift={shift}
              currentHour={currentHour}
              currentDate={currentDate}
              key={hour.toString()}
              tasksWithStartDate={tasksWithStartDate}
              tasksWithoutStartDate={tasksWithShift}
              start={start}
              end={end}
            />
          )
        })}
      </>
    )
  }
)
